import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-red-500" }, " ЕСЛИ ВАШ ПЕРЕВОЗЧИК НДС-НИК ВВЕДИТЕ СУММУ С НДС, ЕСЛИ ВАШ ПЕРЕВОЗЧИК НЕ НДС-НИК,ТО СУММУ БЕЗ НДС ", -1)
const _hoisted_2 = { class: "flex items-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Внести себестоимость за рейс",
    loading: _ctx.isLoading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmitted
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full",
        placeholder: _ctx.getPlaceholder,
        value: _ctx.rate_state.cost_price,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rate_state.cost_price) = $event)),
        "is-invalid": _ctx.state_form$.cost_price.$error,
        "validation-errors": _ctx.state_form$.cost_price.$errors
      }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"]),
      _hoisted_1,
      (_ctx.isFTLTypeTwo)
        ? (_openBlock(), _createBlock(_component_radio_group, {
            key: 0,
            name: "shipment_type",
            value: _ctx.rate_state.payment_rate_type_id,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rate_state.payment_rate_type_id) = $event)),
            options: _ctx.FTL_PAYMENT_RATE_TYPES,
            class: "small my-3"
          }, null, 8, ["value", "options"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.ftlType === 1)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 0,
              value: _ctx.state.is_prepayment,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.is_prepayment) = $event)),
              label: "Предоплата"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}